import { render, staticRenderFns } from "./ShippingMessageThreads.vue?vue&type=template&id=5bb6b67d&scoped=true"
import script from "./ShippingMessageThreads.vue?vue&type=script&lang=js"
export * from "./ShippingMessageThreads.vue?vue&type=script&lang=js"
import style0 from "./ShippingMessageThreads.vue?vue&type=style&index=0&id=5bb6b67d&prod&lang=scss&scoped=true"
import style1 from "./ShippingMessageThreads.vue?vue&type=style&index=1&id=5bb6b67d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb6b67d",
  null
  
)

export default component.exports